import type { ReactNode } from "react";
import { Icon } from "./Icons";

/**
 * The one collapsed-section header: a dashed row with a chevron that turns
 * when open. Credits, Points, Offers and Cards each had their own ▸/▾ copy.
 */
export function Fold({
  open,
  onClick,
  label,
  className = "",
}: {
  open: boolean;
  onClick: () => void;
  label: ReactNode;
  className?: string;
}) {
  return (
    <button type="button" onClick={onClick} aria-expanded={open} className={`fold ${className}`}>
      <span className="min-w-0">{label}</span>
      <Icon name="chevron" size={16} className="chev shrink-0" />
    </button>
  );
}
